export const linkTrackId = (text) => `link-${formatTrackId(text)}`;
function formatTrackId(text) {
    return text
        .trim()
        .replace(/[\s_]/g, "-")
        .replace(/[()\.:,']/g, "")
        .toLowerCase();
}
//# sourceMappingURL=analyticsUtils.js.map